<template>
  <div class="text-center text-dark my-5">
    <b-spinner class="align-middle"></b-spinner>
    <div style="margin:8px 0">
      <strong>Loading...</strong>
    </div>
  </div>
</template>
<script>
export default {
  name: "TableSpiner"
};
</script>
